import React, {useEffect, useContext} from 'react'
import { getOperations, getTasks } from '../api/operations';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import SimpleOperationsList from '../components/operations/SimpleOperationList';
import SimpleTasksList from '../components/operations/SimpleTasksList';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {WebSocketContext} from '../api/socket';

const operationsSorter = (a, b) => {
    if (a.start_date < b.start_date) {
        return 1;
    }
    if (a.start_date > b.start_date) {
        return -1;
    }
    return 0;
};


const AdminOps = (props) => {
  const { user } = props
  const ws = useContext(WebSocketContext);
  const navigate = useNavigate();
  const [opsList, setOpsList] = React.useState({loaded: false, operations: []});
  const [tasksList, setTasksList] = React.useState({loaded: false, tasks: []});
  const [view_all_ops, setViewAllOps] = React.useState(false);
  const [view_all_tasks, setViewAllTasks] = React.useState(false);
    
  useEffect(() => {
    reloadOperations();
    reloadTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, view_all_ops, view_all_tasks]);

  const reloadOperations = () => {
    let params = {};
    if (!view_all_ops) {
        params.status = ["running", "pending", "paused", "errored"];
    }
    getOperations(params).then((r) => {
        setOpsList({loaded: true, operations: r.operations.sort(operationsSorter)});
    }).catch((e) => {
        setOpsList({loaded: true, operations: [], error: e});
    });
  };
  const reloadTasks = () => {
    let params = {limit: 100};
    if (!view_all_tasks) {
        params.status = ["running", "pending", "paused", "errored"];
    }
    getTasks(params).then((r) => {
        setTasksList({loaded: true, tasks: r.tasks});
    }).catch((e) => {
        console.log("Error getting tasks: ", e);
        setTasksList({loaded: true, tasks: [], error: e});
    });
  };

  const onWsOperationUpdate = (data) => {
    let op = data.operation;

    console.log('[WS] Got operation update: ', op);
    setOpsList(state_ops => {
        let ops = state_ops.operations;
        let idx = ops.findIndex((t) => t.uuid === data.operation.uuid);
        if (idx === -1) {
            ops.push(data.operation);
        } else {
            ops[idx] = data.operation;
        }
        let next_state = {...state_ops, "operations": ops.sort(operationsSorter)}
        return next_state;
    });
  };
  const onWsTaskUpdate = (data) => {
    let task = data.task;

    console.log('[WS] Got task update: ', task);
    setTasksList(state_tasks => {
        let tasks = state_tasks.tasks;
        let idx = tasks.findIndex((t) => t.uuid === task.uuid);
        if (idx === -1) {
            tasks.push(task);
        } else {
            tasks[idx] = task;
        }
        let next_state = {...state_tasks, "tasks": tasks}
        return next_state;
    });
  };
  useEffect(() => {
    if (ws === null) {
        return;
    }
    ws.on('operation_update', onWsOperationUpdate);
    ws.on('task_update', onWsTaskUpdate);
    return () => {
        ws.off('operation_update');
        ws.off('task_update');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ws]);

  return (
    <Grid container spacing={4} justifyContent={"center"}>
        <Grid item xs={12} md={12} lg={12}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    minHeight: 183,
                }}
            >
            <Grid container spacing={1} direction={"row"}>
                <Grid item xs={6}>
                <Typography variant="h3">Operations</Typography>
                </Grid>
                <Grid item sx={
                    {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    '& .MuiButton-root': {
                        marginLeft: 1
                    }
                    }} xs={6}>
                <Button variant="contained" color="secondary" onClick={() => reloadOperations()}>Reload</Button>
                <Button variant="contained" color="secondary" onClick={() => setViewAllOps(!view_all_ops)}>
                    {view_all_ops ? "Hide completed" : "Show completed"}
                </Button>
                </Grid>
                <Grid item xs={12}>
                    <SimpleOperationsList
                        operations={opsList.operations}
                        loaded={opsList.loaded}
                        reloadData={reloadOperations}
                        error={opsList.error}
                        onOpClick={(operation) => {
                            navigate(`/admin/ops/${operation.uuid}`);
                        }}
                    />
                </Grid>
                </Grid>
            </Paper>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    minHeight: 183,
                }}
            >
            <Grid container spacing={1} direction={"row"}>
                <Grid item xs={6}>
                    <Typography variant="h3">Tasks</Typography>
                </Grid>
                <Grid item sx={
                    {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    '& .MuiButton-root': {
                        marginLeft: 1
                    }
                    }} xs={6}>
                    <Button variant="contained" color="secondary" onClick={() => reloadOperations()}>Reload</Button>
                    <Button variant="contained" color="secondary" onClick={() => setViewAllTasks(!view_all_tasks)}>
                        {view_all_tasks ? "Hide completed" : "Show completed"}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <SimpleTasksList tasks={tasksList.tasks} loaded={tasksList.loaded} reloadData={reloadTasks} error={tasksList.error} />
                </Grid>
            </Grid>
            </Paper>
        </Grid>
    </Grid>
  )
}

export default AdminOps